// extracted by mini-css-extract-plugin
module.exports = {"results":"Results_results__3qNV6","active":"Results_active__2xD73"};